<template>
  <div>
    <v-row>
      <v-col>
        <v-card flat class="rounded-card" height="100%">
          <v-card-title></v-card-title>
          <v-card-subtitle>
            <span class="text-md-subtitle-1 font-weight-bold">受注件数</span> {{ periodLabel }}
          </v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader
              v-if="collections === null"
              height="300"
              type="image"
              loading
              transition="fade-transition"
            >
            </v-skeleton-loader>
            <bar-chart
              v-else
              :chart-data="collections"
              :options="collectionOptions"
              :style="myStyles"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import BarChart from '../../../../components/BarChart'

export default {
  name: 'DashboardChart',
  components: {
    BarChart
  },
  mixins: [],
  props: {

  },
  data() {
    return {
      periodLabel: null,
      graphicalHeight: 300,
      collectionOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false,
          text: '直近　回収件数',
          fontStyle: 'bold',
          fontSize: 18,
        },
        legend: {
          display: true,
          align: 'end',
        },
        scales: {
          xAxes:[{
            display: true,
            ticks: {
              fontSize: 8,
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              stepSize: 1
            }
          }]
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'start',
            color: '#ffffff',
            // font: function(context) {
            //   let width = context.chart.width;
            //   let size = Math.round(width / 200);
            //   return {
            //     size: size,
            //     weight: 600
            //   };
            // }
            // font: {
            //   weight: 'bold',
            //   size: 12,
            // }
          },
        }
      },
      collections: null,
    }
  },
  computed: {
    myStyles() {
      return {
        height: `${this.graphicalHeight}px`,
        position: 'relative'
      }
    }
  },
  watch: {},
  created() {
    this.fetchCollects().then((content) => {
      this.periodLabel = content.period
      this.collections = {}
      this.collections.labels = content.labels
      this.collections.datasets = content.datasets
    })
  },
  methods: {
    ...mapActions('DriverDashboardCollect', {
      fetchCollects: 'index'
    }),
  }
}
</script>

<style lang="scss">
.v-skeleton-loader__image {
  height: inherit !important;
}

</style>
